import "core-js/modules/es.json.stringify.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/icons/girl-running.png';
var _hoisted_1 = {
  class: "analytics-report"
};
var _hoisted_2 = {
  class: "customized-header d-flex flex-row fl-s-b"
};
var _hoisted_3 = {
  class: "header-title d-flex fl-col fl-j-c"
};
var _hoisted_4 = {
  key: 0,
  class: "progressbar-wrapper d-flex fl-col fl-s-b"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
})], -1);

var _hoisted_6 = {
  class: "loading-text"
};
var _hoisted_7 = {
  class: "one-sec-text"
};
var _hoisted_8 = {
  key: 1,
  class: "explo-analytics-dashboard"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_explo_dashboard = _resolveComponent("explo-dashboard");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    fullscreen: true,
    "show-close": false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("button.analytics")), 1)])]), _createElementVNode("button", {
        class: "close-button d-flex fl-col fl-j-c",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.close && _ctx.close.apply(_ctx, arguments);
        })
      }, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.closeIconContent,
        iconAlt: _ctx.closeIconAlt,
        iconStyle: _ctx.closeIconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])]), _ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("common.loading")), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_progress, {
        percentage: 70,
        indeterminate: true,
        "stroke-width": 26,
        "show-text": false
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("common.one-sec")), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_explo_dashboard, {
        "dash-customer-token": _ctx.getCustomeToken(),
        updateUrlParams: "{true}",
        isProduction: "{true}",
        "refresh-minutes": "{5}",
        variables: JSON.stringify(_ctx.generateVariablesObject())
      }, null, 8, ["dash-customer-token", "variables"])]))];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}